import { connectHook } from '../../connect-hook.js';
import { Switch } from './switch.js';
import { useSwitch } from './switch-hook.js';

export default connectHook(Switch, useSwitch);
